import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DependentService {
  private dependentActualizadaSource = new Subject<void>();
  private readonly baseUrl = environment.apiBaseUrl;

  direccionActualizada$ = this.dependentActualizadaSource.asObservable();

  constructor(private http: HttpClient) {}

  emitirActualizacion() {
    this.dependentActualizadaSource.next();
  }

  obtenerCatalogoParentescos(): Observable<any> {
    const token = localStorage.getItem('accessToken') || '';
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });
    return this.http.get(`${this.baseUrl}/dependents/list`, { headers });
  }
}
